<template>
  <div class="banner-box">
    <div class="login-logos">
      <img src="../../assets/img/logos.png" alt />
    </div>
    <div v-if="indexStatus" @click="imgShow()" class="login-yasuo">
      <img src="../../assets/img/img-daohang.png" alt />
    </div>
    <div v-else @click="imgHide()" class="login-yasuo">
      <img src="../../assets/img/img-guanbi01.png" alt />
    </div>
    <el-row :class="{'menu_banner' : indexStatus==1}">
      <el-col class="menu_left">
        <el-menu :default-active="$route.path" router class="el-menu-demo" mode="vertical">
           <el-menu-item index="/index">
            首页
            <p>Home</p>
          </el-menu-item>
          <el-menu-item index="/introduce">
            业务介绍
            <br />Business Introductio
          </el-menu-item>
          <el-menu-item index="/consultation">
            资讯中心
            <br />Information Center
          </el-menu-item>
          <el-menu-item index="/about">
            关于扬海
            <br />About us
          </el-menu-item>
          <el-menu-item index="/contact">
            联系我们
            <br />Contact us
          </el-menu-item>
        </el-menu>
      </el-col>
    </el-row>
  </div>
</template>
<script>
export default {
  components: {},
  data() {
    return {
      indexStatus: 1
    };
  },

  methods: {
    imgShow() {
      this.indexStatus = 0;
    },
    imgHide() {
      this.indexStatus = 1;
    }
  }
};
</script>
<style>
/* 屏幕可视窗口尺寸大于 480  */
@media screen and (min-width: 300px) and (max-width: 480px) {
  .index-page .lefts {
    width: 100%;
    overflow: auto;
  }
  .menu_banner {
    display: none;
  }
  .menu_left {
    padding-bottom: 700px;
  }
  .login-yasuo {
    display: inline-block !important;
    position: absolute;
    top: 35px;
    right: 35px;
  }
  .login-yasuo img {
    width: 48px;
  }
  .login-titles {
    display: block !important;
  }
  .login-titles img {
    width: 300px;
    padding: 0 92px;
    display: block;
  }

  .login-biaotous {
    display: flex !important;
    flex-direction: column;
    align-items: center;
    color: #fff;
    padding: 300px 0;
  }
  .login-biaotous img {
    width: 40px;
  }
  .conter-bom {
    background: #fff;
    padding: 0 90px;
    display: block !important;
  }
  .conter-bom .page_spirit_bom_right {
    margin: 51px 0;
    height: 1px;
    width: auto;
  }
  .conter-bom .page_spirit_bom_zimu img {
    width: 96%;
  }
  .conter-bom .page_spirit_bom_writing {
    width: auto;
  }
  .conter-bom .right_bottom_new {
    width: auto;
    display: block;
    padding-bottom: 0;
  }
  .conter-bom .right_bottom_new .notice_img {
    padding: 20px 0;
  }
  .conter-bom .notice_right_new {
    padding: 30px 0;
    display: block !important;
  }
  .conter-bom .right_bottom_new .notice_date1 {
    margin: 0;
  }
  .conter-bom .right_bottom_new .notice_title {
    margin: 0;
  }
  .conter-bom .right_bottom_code {
    padding: 0;
    width: auto;
    justify-content: space-between;
  }
  .conter-bom .notice_content_code {
    padding: 100px 0;
    margin: 0 !important;
    display: flex;
  }
  .conter-bom .notice_content_code .notice_content_guanzhu {
    margin: auto;
  }
  .menu_img {
    display: none;
  }
}

.menu_left .el-menu {
  border-right: none;
  background-color: transparent;
}
.menu_left .el-menu .el-menu-item {
  color: #ffffff !important;
  width: 480px;
  height: 110px;
  padding-top: 20px;
  font-size: 18px;
  padding-left: 60px !important;
}
.el-menu-item.is-active {
  background-color: rgba(255, 255, 255, 0.1) !important;
}
.el-submenu__title:hover {
  background-color: rgba(255, 255, 255, 0.1) !important;
}
.el-menu-item:hover {
  background: rgba(255, 255, 255, 0.1) !important;
}
.menu_left .el-menu-item,
.el-submenu__title {
  line-height: 26px;
  font-size: 12px;
}
.img_left {
  text-align: right;
}
.img_left .login-logo {
  position: relative;
}
.img_left img {
  background-size: cover;
  width: 400px;
  height: 195px;
  padding-top: 100px;
}
.login-logos {
  text-align: center;
  padding: 45px 0 25px 80px;
  display: inline-block;
}
.login-yasuo {
  display: none;
}
.login-title {
  display: none;
}
.login-biaotou {
  display: none;
}
.conter-bom {
  display: none;
}
.login-logos img {
  background-size: cover;
  width: 354px;
  height: 60px;
  margin-bottom: 105px;
  margin-top: 50px;
}
.panment_btn {
  position: absolute;
  top: 215px;
  left: 110px;
}
.panment_btn .el-button {
  background-color: transparent;
  color: #fff;
  font-size: 12px;
  width: 170px;
  height: 50px;
}
</style>


// WEBPACK FOOTER //
// src/components/page/banner.vue